import React from "react";
import Link from "next/link";
import styles from "./news_tags.module.scss";

export const NewsTags = ({ tagsList, format, customClasses }) => {
  if (tagsList && tagsList.length > 0) {
    return (
      <div
        className={`${styles.tags_wrapper} ${
          customClasses?.root ? customClasses?.root : ""
        }`}
      >
        <h3 className={styles.tags_title}>Tags</h3>
        <ul className={styles.tags}>
          {tagsList &&
            tagsList?.length > 0 &&
            tagsList?.map((tag, i) => {
              let tagLink = `/news/${format}/tag?limit=8&page=1&tag=${tag?.value}&newsFormat=${format}`;
              if (format == "standard") {
                tagLink = `/news/tag?limit=8&page=1&tag=${tag?.value}`;
              }
              return (
                <li key={i}>
                  <Link legacyBehavior href={tagLink}>
                    <a className={styles.tag_link}>{tag?.label}</a>
                  </Link>
                </li>
              );
            })}
        </ul>
      </div>
    );
  } else {
    return <></>;
  }
};

export default NewsTags;
